import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { IpService } from "../../core/services/essentials/ip.service";
import { AnalyticsViewEnum } from "../consts/shared.const";
import { CookieService } from "../../core/services/cookie/cookie.service";
import { Cookies } from "../enums/app.enums";
interface Analytics{
    jP_ID: number[],
    viewType: string,
    viewSource: number,
    httpAgent:string,
    ip:string;
    jobseekerGId: string;
}

@Injectable({
    providedIn: 'root'
})
export class JobAnalyticsService {
    private ipService = inject(IpService)
    private cookieService = inject(CookieService);
    private analyticsEndpoint = 'https://api.bdjobs.com/JobViewAnalytics/api/JobViewLog/Frontend/InsertJobViewLog'

    private http = inject(HttpClient);

    logView(jobIds: number[], viewType: string):void{
        const userGuid = decodeURIComponent(this.cookieService.getCookie(Cookies.MYBDJOBSGID) ?? '');
        const payload: Analytics = {
            jP_ID: jobIds,
            viewType: viewType,
            viewSource: AnalyticsViewEnum.Frontend as number,
            httpAgent: navigator.userAgent,
            ip: this.ipService.ip() ?? '',
            jobseekerGId: userGuid,
        }
        this.http.post(this.analyticsEndpoint, payload, {withCredentials:true}).subscribe()
    }
}
